import { useLocation, useNavigate } from "react-router-dom";

import useUser from "../../profile/useUser";
import SayagieLogo from "../../../components/SayagieLogo";
import NotificationsPopover from "../../notifications/components/NotificationsPopover";
import CartButton from "./CartButton";
import ProfileAvatar from "./ProfileAvatar";
import { PRIMARY_NAV, accountNav, isNavActive } from "../navItems";

const PrimaryNav = ({ onMenuToggle, menuOpen, onLogout }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useUser();

  const items = [
    ...PRIMARY_NAV.filter((item) => !item.auth || isAuthenticated),
    ...(isAuthenticated ? accountNav() : []),
  ];

  const activate = (item) => {
    if (item.action === "logout") return onLogout();
    if (item.href) return window.open(item.href);

    navigate(item.path);
  };

  return (
    <div className="sy-primary-nav">
      <div className="sy-primary-inner">
        <button
          type="button"
          className="sy-nav-logo"
          onClick={() => navigate("/")}
          aria-label="Sayagie home"
        >
          <SayagieLogo size="header" />
        </button>

        <nav className="sy-nav-links" aria-label="Sections">
          {items.map((item) => {
            const active = isNavActive(item, pathname, items);

            return (
              <button
                type="button"
                key={item.key}
                className={`sy-nav-link${active ? " is-active" : ""}${
                  item.action === "logout" ? " sy-nav-link--logout" : ""
                }`}
                aria-current={active ? "page" : undefined}
                onClick={() => activate(item)}
              >
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="sy-nav-compact-actions">
          {isAuthenticated && (
            <span className="sy-nav-icon-dark">
              <NotificationsPopover />
            </span>
          )}
          <CartButton />
          {isAuthenticated && <ProfileAvatar />}
        </div>

        <button
          type="button"
          className="sy-nav-burger"
          aria-expanded={menuOpen}
          aria-label="Menu"
          onClick={onMenuToggle}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </div>
  );
};

export default PrimaryNav;
